// Common loader functionality
window.WonderLoader = {
  show: function(container = document.body) {
    // Remove existing loader if any
    this.hide();
    
    // Create loader element
    const loader = document.createElement('div');
    loader.id = 'wonder-loader';
    loader.innerHTML = `
      <div class="wonder-loader-content">
        <div class="wonder-loader-spinner"></div>
        <div class="wonder-loader-text">Loading...</div>
      </div>
    `;
    
    // Add to container
    container.appendChild(loader);
  },

  hide: function() {
    const existingLoader = document.getElementById('wonder-loader');
    if (existingLoader) {
      existingLoader.remove();
    }
  }
}; 